import React, { useState, useEffect } from 'react';
import './Feedback.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function Complaints() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState('pending');
  const [actingId, setActingId] = useState(null);

  const fetchReports = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/api/admin/reports?page=${page}&limit=20&status=${status}`,
        { credentials: 'include' }
      );
      const data = await res.json();
      if (data.success) {
        setReports(data.reports || []);
        setTotalPages(data.pagination?.totalPages || 1);
        setTotal(data.pagination?.total || 0);
      } else {
        console.error('Reports API error:', data.error);
        setReports([]);
      }
    } catch (error) {
      console.error('Failed to fetch reports:', error);
      setReports([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchReports();
  }, [page, status]);

  const runAction = async (id, action, confirmMsg) => {
    if (confirmMsg && !window.confirm(confirmMsg)) return;
    setActingId(id);
    try {
      const res = await fetch(`${API_URL}/api/admin/reports/${id}/action`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action }),
      });
      const data = await res.json();
      if (data.success) {
        fetchReports();
      } else {
        alert(data.error || 'Ошибка');
      }
    } catch (error) {
      console.error('Report action failed:', error);
      alert('Ошибка сети');
    }
    setActingId(null);
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const statusLabel = (s) => {
    const map = {
      pending: 'Ожидает',
      dismissed: 'Пропущено',
      comment_deleted: 'Комментарий удалён',
      user_blocked: 'Пользователь заблокирован',
    };
    return map[s] || s;
  };

  return (
    <div className="feedback-page">
      <div className="feedback-header">
        <h1>Жалобы</h1>
        <span className="feedback-count">Всего: {total}</span>
        <select
          value={status}
          onChange={(e) => { setStatus(e.target.value); setPage(1); }}
          style={{ marginLeft: 16, padding: '6px 10px', borderRadius: 8 }}
        >
          <option value="pending">Ожидают</option>
          <option value="all">Все</option>
          <option value="dismissed">Пропущены</option>
          <option value="comment_deleted">Комментарий удалён</option>
          <option value="user_blocked">Заблокированы</option>
        </select>
      </div>

      {loading ? (
        <div className="feedback-loading">Загрузка...</div>
      ) : reports.length === 0 ? (
        <div className="feedback-empty">Нет жалоб</div>
      ) : (
        <div className="feedback-list">
          {reports.map((item) => (
            <div key={item.id} className="feedback-item">
              <div className="feedback-item-header">
                <div className="feedback-user">
                  <span className="feedback-user-name">
                    Жалоба #{item.id} · от {item.reporter_name || item.reporter_id}
                  </span>
                  <span className="feedback-user-id">
                    На: {item.target_user_name || item.target_user_id}
                    {item.news_id ? ` · новость #${item.news_id}` : ''}
                  </span>
                </div>
                <div className="feedback-date">
                  {formatDate(item.created_at)}
                  <div style={{ fontSize: 12, marginTop: 4 }}>{statusLabel(item.status)}</div>
                </div>
              </div>

              <div className="feedback-message" style={{ fontWeight: 500 }}>
                {item.reason}
              </div>

              {item.comment_text && (
                <div
                  className="feedback-message"
                  style={{
                    marginTop: 8,
                    background: 'rgba(0,0,0,0.2)',
                    borderLeft: '3px solid #f59e0b',
                    paddingLeft: 12,
                  }}
                >
                  <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 4 }}>
                    Комментарий {item.comment_id || ''}
                  </div>
                  {item.comment_text}
                </div>
              )}

              {item.status === 'pending' && (
                <div className="feedback-actions" style={{ flexWrap: 'wrap', gap: 8 }}>
                  <button
                    className="feedback-delete-btn"
                    disabled={actingId === item.id}
                    onClick={() => runAction(
                      item.id,
                      'delete_comment',
                      'Удалить этот комментарий?'
                    )}
                  >
                    Удалить комментарий
                  </button>
                  <button
                    className="feedback-delete-btn"
                    style={{ background: '#7f1d1d' }}
                    disabled={actingId === item.id}
                    onClick={() => runAction(
                      item.id,
                      'block_user',
                      `Заблокировать пользователя ${item.target_user_name || item.target_user_id} на всём сервисе?`
                    )}
                  >
                    Заблокировать пользователя
                  </button>
                  <button
                    disabled={actingId === item.id}
                    onClick={() => runAction(item.id, 'dismiss')}
                    style={{
                      padding: '8px 14px',
                      borderRadius: 8,
                      border: '1px solid #475569',
                      background: 'transparent',
                      color: '#cbd5e1',
                      cursor: 'pointer',
                    }}
                  >
                    Пропустить
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div className="feedback-pagination">
          <button disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
            ← Назад
          </button>
          <span>Страница {page} из {totalPages}</span>
          <button disabled={page === totalPages} onClick={() => setPage((p) => p + 1)}>
            Вперёд →
          </button>
        </div>
      )}
    </div>
  );
}

export default Complaints;
